const PropTypes = require('prop-types');
// @ vendor
const React = require('react');

// @ components
const { BrokerProductFileHeader } = require('components/broker/brokerStocksLikeHeader/brokerStocksLikeHeader');

const BrokerETFsHeader = props => {
    return (
        <BrokerProductFileHeader
            modifier="etfs"
            {...props}
        />
    );
};

BrokerETFsHeader.propTypes = {
    getProductDetails: PropTypes.func,
    match: PropTypes.object,
    productFile: PropTypes.object,
    immMyInvestments: PropTypes.object.isRequired,
    noBottomButtons: PropTypes.bool
};

module.exports = BrokerETFsHeader;
